/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 25/09/2023
*/

import * as React from "react";
import "./App.css";

import Landing from "./components/landing/Landing";
import Legal from "./components/legal/Legal";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import { PortfolioPage } from "./pages/PortfolioPage";
import { PortfolioProvider } from "./context/portafolioContext";
import { ScrollToTop } from "./helpers/ScrollToTop";
import { LanguageProvider } from "./context/languageContext";
import { MainLayout } from "./components/layouts/MainLayout";
import { ServicesPage } from "./pages/ServicesPage";
import { IndustriesPage } from "./pages/IndustriesPage";
import { AboutUsPage } from "./pages/AboutUsPage";
import { ContactPage } from "./pages/ContactPage";

let theme = createTheme();
theme = responsiveFontSizes(theme);

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <LanguageProvider>
          <PortfolioProvider>
            <Routes>
              <Route path="/" element={<MainLayout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/industries" element={<IndustriesPage />} />
                <Route path="/about-us" element={<AboutUsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/legal" element={<Legal legalDocument={null} />} />
                <Route path="/legal" element={<Legal legalDocument={null} />} />
                <Route
                  path="/legal/terms"
                  element={<Legal legalDocument={"TERMS"} />}
                />
                <Route
                  path="/legal/privacy"
                  element={<Legal legalDocument={"PRIVACY"} />}
                />
                <Route
                  path="/legal/cookies"
                  element={<Legal legalDocument={"COOKIES"} />}
                />
                <Route path="/portfolio" element={<PortfolioPage />} />
              </Route>
            </Routes>
          </PortfolioProvider>
        </LanguageProvider>
        <ScrollToTop />
      </BrowserRouter>
    </ThemeProvider>
  );
}
